import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Footer from './component/Footer';

import Header from './component/Header/index';
import LandingContainer from './container/LandingPageContainer/index';
import ProjectPageContainer from './container/ProjectPageContainer';
import ScrollTop from './component/ScrollTop';
import LoginPageContainer from './container/LoginPageContainer';
import ProjectDescContainer from './container/ProjectDescContainer';
import NotFound from './component/NotFound';

//component

class App extends React.Component {
  render() {
    return (
      <Router>
        <ScrollTop />
        <div className="main-container">
          <Header />
          {/* <LandingContainer /> */}

          {/* Router */}
          <Switch>
            <Route path="/" exact component={LandingContainer} />
            <Route
              key="project"
              path="/project"
              exact
              component={ProjectPageContainer}
            />
            <Route path="/login" component={LoginPageContainer} />
            <Route
              exact
              path="/project-desc/:id"
              component={ProjectDescContainer}
            />
            <Route
              key="project-category"
              path="/project-category/:category"
              component={ProjectPageContainer}
            />
            <Route component={NotFound} />
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
